/**
 * PostHog ecommerce events.
 */
(function () {
    var CHECKOUT_DEBOUNCE_MS = 400;
    var lastCheckoutStartedAt = 0;
  
    function getPosthog() {
      return typeof window.posthog !== 'undefined' && window.posthog.capture ? window.posthog : null;
    }
  
    function defaultCurrency() {
      return 'USD';
    }
  
    function lineItemUnitPrice(item) {
      var p = parseFloat(item.price);
      if (!isNaN(p) && p > 0) return p;
      if (item.final_line_price != null && item.quantity) {
        return item.final_line_price / item.quantity / 100;
      }
      return 0;
    }
  
    function captureAddToCartFromCartAddBody(data) {
      var ph = getPosthog();
      if (!ph || !data || data.status) return;
      var items = data.items;
      if (!items || !items.length) return;
  
      var currency = defaultCurrency();
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        ph.capture('add_to_cart', {
          content_name: item.product_title || item.title,
          content_ids: [String(item.product_id)],
          content_type: 'product',
          value: lineItemUnitPrice(item),
          currency: currency,
          quantity: item.quantity,
          variant_id: item.variant_id,
        });
      }
    }
  
    function checkoutPropsFromCart(cart) {
      if (!cart || !cart.items || !cart.items.length) return null;
      var ids = cart.items.map(function (i) {
        return String(i.product_id);
      });
      return {
        content_ids: ids,
        content_type: 'product',
        value: (cart.total_price || 0) / 100,
        currency: cart.currency || defaultCurrency(),
      };
    }
  
    function fireCheckoutStarted() {
      var ph = getPosthog();
      if (!ph) return;
  
      var now = Date.now();
      if (now - lastCheckoutStartedAt < CHECKOUT_DEBOUNCE_MS) return;
      lastCheckoutStartedAt = now;
  
      fetch(window.location.origin + '/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var props = checkoutPropsFromCart(cart);
          if (props) ph.capture('checkout_started', props);
        })
        .catch(function () {});
    }
  
    /** Buy-now flows that redirect to /checkout without clicking the checkout button */
    window.pvbPostHogCheckoutStarted = fireCheckoutStarted;
  
    function wrapFetch() {
      if (window.__pvbPosthogFetchWrapped) return;
      window.__pvbPosthogFetchWrapped = true;
  
      var origFetch = window.fetch;
      window.fetch = function () {
        var request = arguments[0];
        var url = typeof request === 'string' ? request : request && request.url;
        return origFetch.apply(this, arguments).then(function (response) {
          if (!response || !response.ok || !url || url.indexOf('/cart/add') === -1) {
            return response;
          }
          response
            .clone()
            .json()
            .then(function (data) {
              captureAddToCartFromCartAddBody(data);
            })
            .catch(function () {});
          return response;
        });
      };
    }
  
    function isCheckoutHref(href) {
      if (!href) return false;
      try {
        var u = new URL(href, window.location.origin);
        var path = u.pathname || '';
        if (path.indexOf('/checkout') === -1) return false;
        if (path.indexOf('/orders/') !== -1 && path.indexOf('thank_you') !== -1) return false;
        return true;
      } catch (e) {
        return false;
      }
    }
  
    function onPointerCheckoutIntent(e) {
      var t = e.target;
      if (!t || !t.closest) return;
  
      var checkoutBtn = t.closest('button[name="checkout"]');
      if (checkoutBtn && !checkoutBtn.disabled) {
        fireCheckoutStarted();
        return;
      }
  
      var shopifyBuyNow = t.closest('[data-shopify="payment-button"]');
      if (shopifyBuyNow) {
        fireCheckoutStarted();
        return;
      }
  
      var dyn = t.closest('.additional-checkout-buttons');
      if (dyn) {
        fireCheckoutStarted();
        return;
      }
  
      var link = t.closest('a[href]');
      if (link && isCheckoutHref(link.getAttribute('href'))) {
        fireCheckoutStarted();
      }
    }
  
    function onCheckoutFormSubmit(e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/checkout') !== -1) {
        fireCheckoutStarted();
      }
    }
  
    /** Catches SPA-style navigations to checkout (e.g. some buy-now redirects) */
    function hookNavigationApi() {
      if (!window.navigation || !window.navigation.addEventListener) return;
      window.navigation.addEventListener('navigate', function (e) {
        var dest = e.destination && e.destination.url;
        if (!dest) return;
        try {
          var u = new URL(dest);
          if (u.pathname.indexOf('/checkout') !== -1 && u.pathname.indexOf('thank_you') === -1) {
            fireCheckoutStarted();
          }
        } catch (err) {}
      });
    }
  
    wrapFetch();
    document.addEventListener('click', onPointerCheckoutIntent, true);
    document.addEventListener('submit', onCheckoutFormSubmit, true);
    hookNavigationApi();
  })();
  